const formatDecimal = (input, decimal = 2) => {
	if (!/^-?\d*\.?\d*$/.test(String(input)) || !input) {
		return input;
	}

	return parseFloat(input).toFixed(decimal);
};

export default formatDecimal;
